import { render, staticRenderFns } from "./TaskFormModal.vue?vue&type=template&id=5ba41f95&scoped=true&"
import script from "./TaskFormModal.vue?vue&type=script&lang=js&"
export * from "./TaskFormModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskFormModal.vue?vue&type=style&index=0&id=5ba41f95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba41f95",
  null
  
)

export default component.exports